import React, { useState, useEffect } from 'react';
import { animated, useSpring } from '@react-spring/web';

import Alert from 'views/Alert.js';
import Appearance from 'styles/Appearance.js';

const AlertStack = ({ alerts, onClose, utils }) => {

    const [animations, animationsApi] = useSpring(() => ({
        config: { mass: 1, tension: 180, friction: 16 },
        opacity: 0
    }));
    const [visible, setVisible] = useState(false);

    const onCloseAlert = alert => {

        // notify sender the alert closed if applciable
        if(typeof(alert.onClose) === 'function') {
            alert.onClose();
        }

        // notify subscribers that alerts have changed
        let targets = alerts.filter(a => a.id !== alert.id);
        onClose(targets);
    }
    
    const show = () => {
        setVisible(true);
        animationsApi.start({
            delay: 100,
            to: async next => {
                await next({ opacity: 1 });
            }
        });
    }
    
    const hide = () => {
        animationsApi({
            to: async next => {
                await next({ opacity: 0 });
                setVisible(false);
            }
        });
    }

    useEffect(() => {
        alerts.length > 0 ? show() : hide();
    }, [alerts]);

    return visible && (
        <div style={{
            alignItems: 'center',
            backgroundColor: Appearance.colors.transparent,
            display: 'flex',
            height: '100dvh',
            inset: 0,
            justifyContent: 'center',
            position: 'fixed',
            zIndex: 9950
        }}>
            <animated.div style={{
                backgroundColor: Appearance.colors.dim,
                backdropFilter: 'blur(8px)',
                bottom: -125,
                height: window.innerHeight + 250,
                inset: 0,
                position: 'fixed',
                top: -125,
                WebkitBackdropFilter: 'blur(8px)',
                ...animations
            }} />
            {alerts.map((alert, index) => (
                <Alert
                {...alert}
                key={alert.id}
                index={(alerts.length - 1) - index}
                onClose={onCloseAlert.bind(this, alert)} 
                utils={utils} />
            ))}
        </div>
    );
}
export default AlertStack;
